/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartDimensionThresholdResponse } from './PartDimensionThresholdResponse';
import {
    PartDimensionThresholdResponseFromJSON,
    PartDimensionThresholdResponseFromJSONTyped,
    PartDimensionThresholdResponseToJSON,
    PartDimensionThresholdResponseToJSONTyped,
} from './PartDimensionThresholdResponse';
import type { PartDimensionResponse } from './PartDimensionResponse';
import {
    PartDimensionResponseFromJSON,
    PartDimensionResponseFromJSONTyped,
    PartDimensionResponseToJSON,
    PartDimensionResponseToJSONTyped,
} from './PartDimensionResponse';
import type { PartResponse } from './PartResponse';
import {
    PartResponseFromJSON,
    PartResponseFromJSONTyped,
    PartResponseToJSON,
    PartResponseToJSONTyped,
} from './PartResponse';

/**
 * 
 * @export
 * @interface PartCatalogSyncItemsResponse
 */
export interface PartCatalogSyncItemsResponse {
    /**
     * 
     * @type {Array<PartResponse>}
     * @memberof PartCatalogSyncItemsResponse
     */
    parts?: Array<PartResponse>;
    /**
     * 
     * @type {Array<PartDimensionResponse>}
     * @memberof PartCatalogSyncItemsResponse
     */
    partDimensions?: Array<PartDimensionResponse>;
    /**
     * 
     * @type {Array<PartDimensionThresholdResponse>}
     * @memberof PartCatalogSyncItemsResponse
     */
    partDimensionThresholds?: Array<PartDimensionThresholdResponse>;
}

/**
 * Check if a given object implements the PartCatalogSyncItemsResponse interface.
 */
export function instanceOfPartCatalogSyncItemsResponse(value: object): value is PartCatalogSyncItemsResponse {
    return true;
}

export function PartCatalogSyncItemsResponseFromJSON(json: any): PartCatalogSyncItemsResponse {
    return PartCatalogSyncItemsResponseFromJSONTyped(json, false);
}

export function PartCatalogSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartCatalogSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(PartResponseFromJSON)),
        'partDimensions': json['partDimensions'] == null ? undefined : ((json['partDimensions'] as Array<any>).map(PartDimensionResponseFromJSON)),
        'partDimensionThresholds': json['partDimensionThresholds'] == null ? undefined : ((json['partDimensionThresholds'] as Array<any>).map(PartDimensionThresholdResponseFromJSON)),
    };
}

export function PartCatalogSyncItemsResponseToJSON(json: any): PartCatalogSyncItemsResponse {
    return PartCatalogSyncItemsResponseToJSONTyped(json, false);
}

export function PartCatalogSyncItemsResponseToJSONTyped(value?: PartCatalogSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(PartResponseToJSON)),
        'partDimensions': value['partDimensions'] == null ? undefined : ((value['partDimensions'] as Array<any>).map(PartDimensionResponseToJSON)),
        'partDimensionThresholds': value['partDimensionThresholds'] == null ? undefined : ((value['partDimensionThresholds'] as Array<any>).map(PartDimensionThresholdResponseToJSON)),
    };
}

